import Landing from "./landing";

export default Landing;

//import LandingError from "./landing-error";

//export default LandingError;